import { z } from 'zod';

const EDDSchema = z.object({
  required: z.boolean(),
  status: z.string(),
});

const POASchema = z.object({
  required: z.boolean(),
  status: z.string(),
  address: z
    .object({
      address_line_1: z.string().nullable(),
      address_line_2: z.string().nullable(),
      city: z.string().nullable(),
      country: z.string().nullable(),
      national_identifier: z.string().nullable(),
      postcode: z.string().nullable(),
      state: z.string().nullable(),
    })
    .optional(),
});

const CurrencyStatusSchema = z.object({
  status: z.string(),
  currencyData: z.any().optional(), // Raw currency data from get-applications
  tncAccepted: z.boolean(),
  isActivated: z.boolean().optional(),
  edd: EDDSchema.optional(),
  poa: POASchema.optional(),
  activatedAt: z.string().optional(),
  rejectionReason: z.string().optional(),
});

export const GetCurrenciesResultSchema = z.object({
  data: z.object({
    USD: CurrencyStatusSchema.optional(),
    EUR: CurrencyStatusSchema.optional(),
    GBP: CurrencyStatusSchema.optional(),
    AED: CurrencyStatusSchema.optional(),
  }),
  userType: z.enum(['retail', 'institutional', 'INDIVIDUAL', 'INSTITUTIONAL']),
  timestamp: z.string(),
});

export type GetCurrenciesResult = z.infer<typeof GetCurrenciesResultSchema>;

export interface GetCurrenciesParams {}
